// extracted by mini-css-extract-plugin
export var alignCenter = "_bf-d";
export var bannerShown = "_bf-6";
export var buttonContent = "_bf-0";
export var cardList = "_bf-1";
export var centerContent = "_bf-2";
export var chevron = "_bf-3";
export var closePanelButton = "_bf-k";
export var conversationContextContainer = "_bf-l";
export var conversationDetailContainer = "_bf-4";
export var detailWrapper = "_bf-7";
export var dropdownButton = "_bf-e";
export var dropdownTitle = "_bf-9";
export var fullHeight = "_bf-5";
export var hidden = "_bf-a";
export var icon = "_bf-b";
export var mergeSuggestionWrapper = "_bf-m";
export var panel = "_bf-i";
export var portalButtonsWrapper = "_bf-c";
export var right = "_bf-j";
export var tableSummaryContainer = "_bf-8";
export var tableSummaryHeader = "_bf-g";
export var threeDotsButton = "_bf-f";
export var wide = "_bf-h";